module.exports = __webpack_public_path__ + "static/media/iconSaveAccount.c0a7beb9.svg";